// removed by extract-text-webpack-plugin
module.exports = {"container":"Ji4ihCgX9RFosfGrdiEqv"};


//////////////////
// WEBPACK FOOTER
// ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!./~/vue-style-loader!./~/css-loader?{"minimize":true,"sourceMap":true,"localIdentName":"[hash:base64]","modules":true,"importLoaders":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3bac03bb","scoped":false,"hasInlineConfig":false}!./~/less-loader/dist/cjs.js?{"sourceMap":true}!./src/components/live-coach-call/toolbar/toolbar.less
// module id = eOD7
// module chunks = 1